import { useState } from "react";
import { ClipboardPaste, Upload, FileSpreadsheet, AlertTriangle, CheckCircle2 } from "lucide-react";
import { C, Panel, Kpi, Serif, Label } from "./ui";
import { MIGRATION } from "./adminData";

const MODES = [
  { id: "paste", label: "Paste rows", icon: ClipboardPaste, desc: "Copy-paste from a spreadsheet" },
  { id: "csv", label: "Upload CSV / XLSX", icon: Upload, desc: "Bulk file import" },
  { id: "broker", label: "Broker template", icon: FileSpreadsheet, desc: "Insurer-formatted export" },
];

export default function ImportMigration() {
  const [mode, setMode] = useState("csv");
  return (
    <div>
      <Label>Legacy migration</Label>
      <Serif size={26} style={{ marginTop: 4, marginBottom: 6 }}>Import</Serif>
      <div style={{ fontSize: 12, color: C.slate, marginBottom: 18 }}>Reconcile and import the legacy client base. Nothing is written until you confirm.</div>

      <div style={{ display: "flex", gap: 10, marginBottom: 18 }}>
        {MODES.map((m) => {
          const on = mode === m.id; const Icon = m.icon;
          return (
            <button key={m.id} onClick={() => setMode(m.id)} data-testid={`import-mode-${m.id}`}
              style={{ flex: 1, textAlign: "left", padding: 16, background: on ? C.navy : "#fff", color: on ? "#fff" : C.ink, border: `1px solid ${on ? C.navy : "rgba(26,30,36,0.1)"}`, borderRadius: 10, cursor: "pointer" }}>
              <Icon size={20} color={on ? "#fff" : C.navy} />
              <div style={{ fontSize: 14, fontWeight: 700, marginTop: 8 }}>{m.label}</div>
              <div style={{ fontSize: 12, opacity: on ? 0.8 : 1, color: on ? "#fff" : C.slate, marginTop: 2 }}>{m.desc}</div>
            </button>
          );
        })}
      </div>

      <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
        <Kpi label="Records" value={MIGRATION.total.toLocaleString()} mono />
        <Kpi label="Unique IDs" value={MIGRATION.unique.toLocaleString()} accent={C.green} mono />
        <Kpi label="Duplicates" value={MIGRATION.duplicates} accent={C.red} mono />
        <Kpi label="Have app" value={MIGRATION.hasApp.toLocaleString()} accent={C.green} mono />
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "minmax(0,1fr) minmax(0,1fr)", gap: 16 }}>
        <Panel>
          <Label style={{ marginBottom: 12 }}>Source files (4)</Label>
          {MIGRATION.files.map((f) => (
            <div key={f.src} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderTop: "1px solid rgba(26,30,36,0.06)", fontSize: 13 }}>
              <span><b>{f.insurer}</b> <span style={{ color: C.slate, fontFamily: "'JetBrains Mono', monospace", fontSize: 11 }}>· {f.src}</span></span>
              <span style={{ fontFamily: "'JetBrains Mono', monospace", color: C.slate }}>{f.records.toLocaleString()} rows</span>
            </div>
          ))}
        </Panel>
        <Panel>
          <Label style={{ marginBottom: 12 }}>Pre-flight checks</Label>
          <Check ok={false} text={`${MIGRATION.duplicates} duplicate IDs need a keep/merge decision`} />
          <Check ok={false} text="9 records missing a surname" />
          <Check ok={false} text="67 non-standard IDs (possible fleet / vehicle)" />
          <Check ok text="2,923 unique identities ready to import" />
          <button data-testid="import-confirm" style={{ marginTop: 14, width: "100%", padding: 13, background: C.ink, color: "#fff", border: 0, borderRadius: 10, fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
            Review &amp; confirm import
          </button>
        </Panel>
      </div>
    </div>
  );
}

function Check({ ok, text }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 9, padding: "8px 0", borderTop: "1px solid rgba(26,30,36,0.06)", fontSize: 13 }}>
      {ok ? <CheckCircle2 size={16} color={C.green} /> : <AlertTriangle size={16} color={C.amber} />}
      <span style={{ color: C.ink }}>{text}</span>
    </div>
  );
}
